"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchResults = void 0;
var _react = _interopRequireDefault(require("react"));
const useSearchResults = () => {
  return _react.default.useState({
    isLoading: false,
    hasExecutedQuery: false,
    showTypes: true,
    statuses: [],
    results: []
  });
};
exports.useSearchResults = useSearchResults;
//# sourceMappingURL=search.js.map